import { UsersIcon } from "lucide-react";

import { IconData } from "simplydo/react/ui/icon";

export type InvitationText = {
  title: string;
  fullTitle: string;
  youInvited: string;
  hasInvitedYou: string;
  goTo?: string;
  dismiss: string;
  invalid: string;
};

export type InvitationViewModel = {
  icon: IconData;
  link: string | null;
  isInvalid: boolean;
  text: InvitationText;
  showAccept?: boolean;
  showDismiss?: boolean;
  acceptInvite?: () => void;
  rejectInvite?: () => void;
  removeInvite?: () => void;
};

export const emptyInvitationViewModel = (): InvitationViewModel => ({
  icon: UsersIcon,
  link: null,
  isInvalid: false,
  text: {
    title: "",
    fullTitle: "",
    youInvited: "",
    hasInvitedYou: "",
    dismiss: "",
    invalid: "",
  },
});
